import styled from 'styled-components';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { ReactComponent as Logo } from '../../../assets/img/Logo.svg';
import { ReactComponent as Content } from '../../../assets/img/icons/nav/cotent.svg';
import { ReactComponent as Campaign } from '../../../assets/img/icons/nav/compaign.svg';
import { ReactComponent as Audience } from '../../../assets/img/icons/nav/audience.svg';
import { ReactComponent as Analytics } from '../../../assets/img/SidebarAnalyticsIcon.svg';
import { ReactComponent as Flow } from '../../../assets/img/icons/nav/Flow.svg';
import { ReactComponent as Setting } from '../../../assets/svgs/SettingIcon.svg';
import { ReactComponent as NewTabOpen } from '../../../assets/img/icons/newTabOpen.svg';
import { getPlanType } from 'utils';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { resetAllTabsFilter } from 'modules/Analytics/utils';
import AccountPopover from 'modules/Account/AccountPopover';
import { Popover } from 'antd';

const Mainnav = (props) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const [showAnalytics, setShowAnalytics] = useState();
  const [showAutomation, setShowAutomation] = useState(true); //  Refactor Code: Remove this line and uncomment the above
  const backOverlayForConfirm = useSelector((state) => state.uiReducer.backOverlayForConfirm);
  const backOverlayOnMainNav = useSelector((state) => state.uiReducer.backOverlayOnMainNav);
  const planType = useSelector((state) => state.user.planType);
  const salesXUsagePermission = useSelector((state) => state.user.salesXUsage);
  const isDesign = window.location.pathname.includes('design');
  // will be shown to the users who has the permission for export widget
  const settingsPermission = useSelector((state) => state?.user?.userData?.settings_permission);

  useEffect(() => {
    const isAnalytics = window.location.pathname.includes('analytics');
    if (isAnalytics === false) {
      resetAllTabsFilter(false);
    }
  }, [window.location.pathname]);

  useEffect(() => {
    let isEnterprise = planType?.toUpperCase() === 'ENTERPRISE';
    if (!planType) {
      isEnterprise = getPlanType().toUpperCase() === 'ENTERPRISE';
    }
    setShowAnalytics(isEnterprise);
    setShowAutomation(isEnterprise);
  }, [planType]);

  const PopoverAnalytics = () => {
    return (
      <PopoverWrapper>
        <div className="campaign-analytics" onClick={() => history.push('/analytics')}>
          Campaign Analytics
        </div>
        <div className="salesX-usage" onClick={() => window.open('https://workbench.xiqonline.com/dashboards/app_usage_main/', '_blank')}>
          <span>
            Sales Xelerator<sup>TM</sup> Usage
          </span>
          <span style={{ marginLeft: '9px' }}>
            <NewTabOpen />
          </span>
        </div>
      </PopoverWrapper>
    );
  };

  return (
    <>
      <Wrapper className="side-nav">
        {isDesign ? (
          <ul>
            <li className="logo" data-id="menu-li-logo">
              <Link onClick={(e) => props.onExit('/campaigns', e)}>
                <Logo />
              </Link>
            </li>
            <li className={path.includes('/campaigns') || path.includes('publish') ? 'active' : ''} data-id="menu-li-campaigns">
              <Link onClick={(e) => props.onExit('/campaigns', e)} data-id="menu-a-campaigns">
                <Campaign />
                <span className="menu-label" data-id="menu-label-campaigns">
                  Campaigns
                </span>
              </Link>
            </li>
            <li className={path.includes('/design') || path.includes('/content') ? 'active' : ''} data-id="menu-li-content">
              <Link onClick={(e) => props.onExit('/content/explorer/', e)} data-id="menu-a-content">
                <Content />
                <span className="menu-label" data-id="menu-label-content">
                  Content
                </span>
              </Link>
            </li>
            <li className={path.includes('/audiences') ? 'active' : ''} data-id="menu-li-audience">
              <Link onClick={(e) => props.onExit('/audiences/', e)} data-id="menu-a-audience">
                <Audience />
                <span className="menu-label" data-id="menu-label-audience">
                  Audience
                </span>
              </Link>
            </li>
            {showAnalytics && salesXUsagePermission ? (
              <li className={path.includes('/analytics') ? 'active' : ''} data-id="menu-li-analytics">
                <Popover
                  placement="rightTop"
                  content={<PopoverAnalytics />}
                  overlayClassName="analytics-popover"
                  getPopupContainer={() => document.querySelectorAll('.side-nav')[0]}
                >
                  <a>
                    <Analytics />
                    <span className="menu-label" data-id="menu-label-analytics">
                      Analytics
                    </span>
                  </a>
                </Popover>
              </li>
            ) : showAnalytics ? (
              <li className={path.includes('/analytics') ? 'active' : ''} data-id="menu-li-analytics">
                <Link to="/analytics/">
                  <Analytics />
                  <span className="menu-label" data-id="menu-label-analytics">
                    Analytics
                  </span>
                </Link>
              </li>
            ) : null}
            {showAutomation && (
              <li className={path.includes('/automation') ? 'active' : ''} data-id="menu-li-automation">
                <Link onClick={(e) => props.onExit('/automation', e)}>
                  <Flow />
                  <span className="menu-label" data-id="menu-label-automation">
                    Workflows
                  </span>
                </Link>
              </li>
            )}
            {settingsPermission && (
              <li className={`manage marginBottom ${path.includes('/settings') ? 'active' : ''}`} data-id="menu-li-settings">
                <Link to={'/settings'}>
                  <Setting />
                  <span className="menu-label" data-id="menu-label-settings">
                    Settings
                  </span>
                </Link>
              </li>
            )}

            <li className="sign-out" data-id="menu-li-sign-out">
              <a>
                <span className="Workbench-nav" data-id="menu-label-sign-out">
                  Workbench
                </span>
              </a>
              <AccountPopover />
            </li>
          </ul>
        ) : (
          <ul>
            <li className="logo" data-id="menu-li-logo">
              <Link
                onClick={isDesign ? (e) => props.onExit('/campaigns', e) : undefined}
                to={!isDesign ? '/campaigns' : ''}
                data-id="menu-a-sign-out"
              >
                <Logo />
              </Link>
            </li>
            <li className={path.includes('/campaigns') || path.includes('publish') ? 'active' : ''} data-id="menu-li-campaigns">
              <Link to="/campaigns" data-id="menu-a-campaigns">
                <Campaign />
                <span className="menu-label" data-id="menu-label-campaigns">
                  Campaigns
                </span>
              </Link>
            </li>
            <li className={path.includes('/design') || path.includes('/content') ? 'active' : ''} data-id="menu-li-content">
              <Link
                onClick={isDesign ? (e) => props.onExit('/content/explorer/', e) : undefined}
                to={!isDesign ? '/content/explorer/' : ''}
                data-id="menu-a-content"
              >
                <Content />
                <span className="menu-label" data-id="menu-label-content">
                  Content
                </span>
              </Link>
            </li>
            <li className={path.includes('/audiences') ? 'active' : ''} data-id="menu-li-audience">
              <Link to="/audiences/">
                <Audience />
                <span className="menu-label" data-id="menu-label-audience">
                  Audience
                </span>
              </Link>
            </li>
            {showAnalytics && salesXUsagePermission ? (
              <li className={path.includes('/analytics') ? 'active' : ''} data-id="menu-li-analytics">
                <Popover
                  placement="rightTop"
                  content={<PopoverAnalytics />}
                  overlayClassName="analytics-popover"
                  getPopupContainer={() => document.querySelectorAll('.side-nav')[0]}
                >
                  <a>
                    <Analytics />
                    <span className="menu-label" data-id="menu-label-analytics">
                      Analytics
                    </span>
                  </a>
                </Popover>
              </li>
            ) : showAnalytics ? (
              <li className={path.includes('/analytics') ? 'active' : ''} data-id="menu-li-analytics">
                <Link to="/analytics/">
                  <Analytics />
                  <span className="menu-label" data-id="menu-label-analytics">
                    Analytics
                  </span>
                </Link>
              </li>
            ) : null}
            {showAutomation && (
              <li className={path.includes('/automation') ? 'active' : ''} data-id="menu-li-automation">
                <Link to={'/automation'}>
                  <Flow />
                  <span className="menu-label" data-id="menu-label-automation">
                    Workflows
                  </span>
                </Link>
              </li>
            )}
            {settingsPermission && (
              <li className={`manage marginBottom ${path.includes('/settings') ? 'active' : ''}`} data-id="menu-li-settings">
                <Link to={'/settings'}>
                  <Setting />
                  <span className="menu-label" data-id="menu-label-settings">
                    Settings
                  </span>
                </Link>
              </li>
            )}
            <li className="sign-out" data-id="menu-li-sign-out">
              <a>
                <span className="Workbench-nav" data-id="menu-label-sign-out">
                  Workbench
                </span>
              </a>
              <AccountPopover />
            </li>
          </ul>
        )}
        {backOverlayForConfirm ? <div className="back-overlay" /> : null}
        {backOverlayOnMainNav ? <div className="back-overlay-dark" /> : null}
      </Wrapper>
    </>
  );
};

export default Mainnav;

const PopoverWrapper = styled.div`
  font-family: 'Roboto';
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: -0.35641855001449585px;
  text-align: left;
  color: #414a4f;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
    line-height: 18px;
  }
  div {
    :hover {
      cursor: pointer;
      color: #1ec252;
    }
  }
  .campaign-analytics {
    margin-bottom: 12px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-bottom: 6px;
    }
  }
  .salesX-usage {
    span {
      a {
        color: #414a4f;
        :hover {
          color: #1ec252;
        }
      }
    }
  }
`;

const Wrapper = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  width: 88px;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    width: 63px;
  }
  /* the following class: 'back-overlay' is for the case of Confirm box and show the greyed out overlay in the background of the Main Nav as well. */
  .marginBottom {
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-bottom: 130px;
    }
    @media all and (max-height: 890px) and (min-height: 730px) {
      margin-bottom: 220px;
    }
  }
  .back-overlay {
    height: 100vh;
    width: 100%;
    background: grey;
    opacity: 0.2;
    top: 0;
    left: 0;
  }
  .back-overlay-dark {
    height: 100vh;
    width: 89px;
    opacity: 0.6;
    top: 0;
    left: 0;
    background-color: black;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 63px;
    }
  }
  ul {
    margin: 0px;
    padding: 0;
    display: block;
    min-height: 100vh;
    position: relative;
    border-right: 1px solid #e7e7e7;
    background: rgba(255, 255, 255, 0.57);
    float: left;
    width: 89px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 63px;
    }
    li {
      display: block;
      border-radius: 8px;
      text-align: center;
      padding: 8px 0;
      margin: 25px 10px;
      transition: 0.5s;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 6px;
        padding: 3px 0;
        margin: 25px 7px;
      }
      @media all and (max-width: 1600px) {
        margin: 12px 7px;
      }
      &.active,
      &:hover:not(.logo) {
        background: #ebf5ee;
        a {
          color: #27ce0a;
          svg path {
            fill: #27ce0a;
          }
          .menu-label {
            opacity: 1;
          }
        }
      }
      &.manage {
        &.active,
        &:hover:not(.logo) {
          svg path[stroke] {
            stroke: #27ce0a;
          }
        }
      }
      &.logo {
        margin-bottom: 45px;
        margin-top: 39px;
        @media all and (max-height: 786px) {
          margin-bottom: 35px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            height: 18px;
            width: auto;
          }
        }
      }
      &.sign-out {
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 60px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 43px;
        }
        &:hover {
          background: transparent;
        }
        margin: 20px 10px !important;
      }
      a {
        text-decoration: none;
        display: block;
        transition: 0.5s;
        .Workbench-nav {
          color: #27ce0a;
          font-size: 24px;
          font-weight: 600;
          -ms-transform: rotate(-90deg);
          transform: rotate(-90deg);
          display: block;
          margin-bottom: 25px;
          letter-spacing: -0.6px;
          font-family: 'Roboto Slab', serif;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            margin-bottom: 18px;
            font-size: 17px;
          }
        }
        svg {
          transition: 0.5s;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 18px;
            height: auto;
          }
        }
        .menu-label {
          color: #424b50;
          font-weight: 800;
          font-size: 12px;
          text-align: center;
          display: block;
          transition: 0.5s;
          opacity: 0;
          letter-spacing: -0.3px;
          font-family: 'Roboto', sans-serif;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 9px;
          }
        }
      }
    }
  }
  .analytics-popover {
    .ant-popover-content {
      .ant-popover-arrow {
        border-radius: 3px;
        box-shadow: -5px 5px 5px rgba(0, 0, 0, 0.07);
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 2px;
        }
      }
      .ant-popover-inner {
        width: max-content;
        border-radius: 8px;
        .ant-popover-inner-content {
          padding: 16px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 12px 16px;
          }
        }
      }
    }
  }
`;
